import { render, staticRenderFns } from "./CardModalCompany.vue?vue&type=template&id=a0079ccc&scoped=true"
import script from "./CardModalCompany.vue?vue&type=script&lang=js"
export * from "./CardModalCompany.vue?vue&type=script&lang=js"
import style0 from "./CardModalCompany.vue?vue&type=style&index=0&id=a0079ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0079ccc",
  null
  
)

export default component.exports